import ContentConnected from './ContentConnected'
export default ContentConnected
